import { render } from "./CrearFactura.vue?vue&type=template&id=d52732ea&scoped=true"
import script from "./CrearFactura.vue?vue&type=script&lang=js"
export * from "./CrearFactura.vue?vue&type=script&lang=js"

import "./CrearFactura.vue?vue&type=style&index=0&id=d52732ea&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52732ea"]])

export default __exports__